import axios from 'axios'

export default {
  state: {
    hngrow_list: null,
  },
  getters: {
    getHnGrowList: (s) => s.hngrow_list,
  },
  mutations: {
    setHnGrowList: (s, list) =>
      (s.hngrow_list = list.filter((el) => el.translates.length)),
  },
  actions: {
    fetchHnGrowList(ctx, lang = 'ru') {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `api/v3/grow/items/?language=${lang}`,
      })
        .then((response) => {
          const list = response.data.results
          ctx.commit('setHnGrowList', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    HnGrowSetVideoProgress(ctx, { id, progress }) {
      const fd = new FormData()
      fd.append('progress', progress)
      return axios({
        method: 'POST',
        data: fd,
        url: `/api/v3/grow/items/${id}/progress/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    HnGrowSetLike(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/grow/items/${id}/like/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    HnGrowSetView(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/grow/items/${id}/view/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    HnGrowSetFavorite(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/grow/items/${id}/favorite/`,
      }).catch((error) => {
        console.error(error)
      })
    },
  },
}
